/**
 * Performance Debug Utility
 * Р’РєР»СЋС‡Р°РµС‚СЃСЏ С‡РµСЂРµР· ?perf=1 РІ URL
 * Р›РѕРіРёСЂСѓРµС‚ РІСЂРµРјСЏ mount СЃС‚СЂР°РЅРёС†, TTI, РїСЂРµРґСѓРїСЂРµР¶РґРµРЅРёСЏ Рѕ С‚СЏР¶РµР»С‹С… РѕРїРµСЂР°С†РёСЏС…
 */

// РџСЂРѕРІРµСЂСЏРµРј, РІРєР»СЋС‡РµРЅ Р»Рё perf СЂРµР¶РёРј
export const isPerfMode = (): boolean => {
  if (typeof window === 'undefined') return false;
  return new URLSearchParams(window.location.search).get('perf') === '1';
};

// Р¦РІРµС‚Р° РґР»СЏ РєРѕРЅСЃРѕР»Рё
const COLORS = {
  info: 'color: #4fc3f7; font-weight: bold;',
  warn: 'color: #ffb74d; font-weight: bold;',
  error: 'color: #ef5350; font-weight: bold;',
  success: 'color: #81c784; font-weight: bold;',
  time: 'color: #ce93d8; font-weight: bold;',
};

// Р›РѕРіРёСЂРѕРІР°РЅРёРµ СЃ РїСЂРµС„РёРєСЃРѕРј
const log = (type: keyof typeof COLORS, message: string, ...args: unknown[]) => {
  if (!isPerfMode()) return;
  console.log(`%c[PERF] ${message}`, COLORS[type], ...args);
};

// Р—Р°РјРµСЂ РІСЂРµРјРµРЅРё mount РєРѕРјРїРѕРЅРµРЅС‚Р°
export const measureMount = (componentName: string): (() => void) => {
  if (!isPerfMode()) return () => {};
  
  const startTime = performance.now();
  log('info', `вЏ±пёЏ ${componentName} mounting...`);
  
  return () => {
    const duration = performance.now() - startTime;
    const color = duration > 100 ? 'warn' : 'success';
    log(color, `вњ… ${componentName} mounted in ${duration.toFixed(2)}ms`);
    
    if (duration > 200) {
      log('error', `рџђў SLOW MOUNT: ${componentName} took ${duration.toFixed(0)}ms (>200ms threshold)`);
    }
  };
};

// Р—Р°РјРµСЂ TTI (Time to Interactive) РїРѕСЃР»Рµ РЅР°РІРёРіР°С†РёРё
export const measureTTI = (pageName: string): void => {
  if (!isPerfMode()) return;
  
  const startTime = performance.now();
  
  // Р–РґС‘Рј СЃР»РµРґСѓСЋС‰РёР№ idle callback РёР»Рё fallback С‡РµСЂРµР· requestAnimationFrame
  const measureEnd = () => {
    const tti = performance.now() - startTime;
    const color = tti > 300 ? 'warn' : 'success';
    log(color, `рџЋЇ TTI for ${pageName}: ${tti.toFixed(2)}ms`);
    
    if (tti > 500) {
      log('error', `рџђЊ SLOW TTI: ${pageName} took ${tti.toFixed(0)}ms to become interactive`);
    }
  };
  
  if ('requestIdleCallback' in window) {
    (window as any).requestIdleCallback(measureEnd, { timeout: 2000 });
  } else {
    requestAnimationFrame(() => {
      requestAnimationFrame(measureEnd);
    });
  }
};

// РџСЂРµРґСѓРїСЂРµР¶РґРµРЅРёРµ Рѕ Р±РѕР»СЊС€РѕРј Р±Р°С‚С‡Рµ РєР°СЂС‚РѕС‡РµРє
export const warnLargeBatch = (componentName: string, itemCount: number, threshold = 10): void => {
  if (!isPerfMode()) return;
  
  if (itemCount > threshold) {
    log('warn', `вљ пёЏ LARGE BATCH: ${componentName} rendering ${itemCount} items at once (threshold: ${threshold})`);
    log('info', `рџ’Ў Consider using batch rendering or virtualization`);
  }
};

// РџСЂРѕРІРµСЂРєР° РёР·РѕР±СЂР°Р¶РµРЅРёР№ РЅР° lazy loading Рё СЂР°Р·РјРµСЂС‹
export const checkImageOptimization = (containerSelector: string): void => {
  if (!isPerfMode()) return;
  
  // РћС‚РєР»Р°РґС‹РІР°РµРј РїСЂРѕРІРµСЂРєСѓ РґРѕ СЃР»РµРґСѓСЋС‰РµРіРѕ idle
  const check = () => {
    const container = document.querySelector(containerSelector);
    if (!container) return;
    
    const images = container.querySelectorAll('img');
    let issues = 0;
    
    images.forEach((img, index) => {
      const warnings: string[] = [];
      
      if (!img.hasAttribute('loading') || img.getAttribute('loading') !== 'lazy') {
        warnings.push('missing loading="lazy"');
      }
      
      if (!img.hasAttribute('decoding') || img.getAttribute('decoding') !== 'async') {
        warnings.push('missing decoding="async"');
      }
      
      if (!img.hasAttribute('width') && !img.hasAttribute('height')) {
        const style = window.getComputedStyle(img);
        const hasFixedSize = style.width !== 'auto' && style.height !== 'auto';
        if (!hasFixedSize) {
          warnings.push('no fixed dimensions (causes layout shift)');
        }
      }
      
      if (warnings.length > 0) {
        issues++;
        log('warn', `рџ–јпёЏ Image #${index + 1} issues: ${warnings.join(', ')}`, img.src?.slice(0, 50));
      }
    });
    
    if (issues === 0 && images.length > 0) {
      log('success', `вњ… All ${images.length} images in ${containerSelector} are optimized`);
    } else if (issues > 0) {
      log('error', `рџ–јпёЏ ${issues}/${images.length} images have optimization issues`);
    }
  };
  
  if ('requestIdleCallback' in window) {
    (window as any).requestIdleCallback(check, { timeout: 3000 });
  } else {
    setTimeout(check, 1000);
  }
};

// Р›РѕРіРёСЂРѕРІР°РЅРёРµ РЅР°РІРёРіР°С†РёРё
export const logNavigation = (from: string, to: string): void => {
  if (!isPerfMode()) return;
  log('info', `рџ§­ Navigation: ${from} в†’ ${to}`);
};

// РҐСѓРє РґР»СЏ РёСЃРїРѕР»СЊР·РѕРІР°РЅРёСЏ РІ РєРѕРјРїРѕРЅРµРЅС‚Р°С…
export const usePerfMount = (componentName: string): void => {
  if (!isPerfMode()) return;
  
  // РСЃРїРѕР»СЊР·СѓРµРј РіР»РѕР±Р°Р»СЊРЅС‹Р№ РѕР±СЉРµРєС‚ РґР»СЏ С…СЂР°РЅРµРЅРёСЏ РІСЂРµРјРµРЅРё РЅР°С‡Р°Р»Р°
  const key = `__perf_mount_${componentName}`;
  if (!(window as any)[key]) {
    (window as any)[key] = performance.now();
  }
};

// Р¤РёРЅР°Р»РёР·Р°С†РёСЏ Р·Р°РјРµСЂР° mount (РІС‹Р·С‹РІР°С‚СЊ РІ useEffect)
export const finishPerfMount = (componentName: string): void => {
  if (!isPerfMode()) return;
  
  const key = `__perf_mount_${componentName}`;
  const startTime = (window as any)[key];
  if (startTime) {
    const duration = performance.now() - startTime;
    delete (window as any)[key];
    
    const color = duration > 100 ? 'warn' : 'success';
    log(color, `вњ… ${componentName} mounted in ${duration.toFixed(2)}ms`);
    
    if (duration > 200) {
      log('error', `рџђў SLOW MOUNT: ${componentName} took ${duration.toFixed(0)}ms`);
    }
  }
};

// РРЅРёС†РёР°Р»РёР·Р°С†РёСЏ perf СЂРµР¶РёРјР°
export const initPerfMode = (): void => {
  if (!isPerfMode()) return;
  
  console.log('%cрџ”§ PERF DEBUG MODE ENABLED', 'color: #d4af37; font-size: 16px; font-weight: bold;');
  console.log('%cAdd ?perf=1 to URL to enable performance logging', 'color: #888;');
  console.log('%cв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђ', 'color: #444;');
  
  // Р›РѕРіРёСЂСѓРµРј Р±Р°Р·РѕРІСѓСЋ РёРЅС„РѕСЂРјР°С†РёСЋ РѕР± СѓСЃС‚СЂРѕР№СЃС‚РІРµ
  const nav = navigator as any;
  log('info', `рџ“± Device info:`, {
    cores: nav.hardwareConcurrency || 'unknown',
    memory: nav.deviceMemory ? `${nav.deviceMemory}GB` : 'unknown',
    connection: nav.connection?.effectiveType || 'unknown',
    isTelegram: !!(window as any).Telegram?.WebApp,
  });
};

// Debug scroll container - РґР»СЏ РґРёР°РіРЅРѕСЃС‚РёРєРё РїСЂРѕР±Р»РµРј СЃРѕ СЃРєСЂРѕР»Р»РѕРј РІ Telegram WebView
export const debugScrollContainer = (containerSelector: string, activeTab: string): void => {
  if (!isPerfMode()) return;
  
  const container = document.querySelector(containerSelector) as HTMLElement;
  if (!container) {
    log('error', `вќЊ Scroll container not found: ${containerSelector}`);
    return;
  }
  
  const info = {
    selector: containerSelector,
    activeTab,
    clientHeight: container.clientHeight,
    scrollHeight: container.scrollHeight,
    scrollTop: container.scrollTop,
    canScroll: container.scrollHeight > container.clientHeight,
    overflow: window.getComputedStyle(container).overflow,
    overflowY: window.getComputedStyle(container).overflowY,
    touchAction: window.getComputedStyle(container).touchAction,
  };
  
  log('info', `рџ“њ Scroll debug:`, info);
  
  if (!info.canScroll) {
    log('warn', `вљ пёЏ Content fits in viewport - no scroll needed`);
  }
};
